import { PlaySquareOutlined, PauseOutlined } from "@ant-design/icons";

export const accionConfig = {
  1: {
    icon: (
      <PlaySquareOutlined
        className="custom-icon"
        style={{ fontSize: "36px", color: "white" }}
      />
    ),
    accion: false,
  }, // pendiente → pausar
  2: {
    icon: (
      <PauseOutlined
        className="custom-icon"
        style={{ fontSize: "36px", color: "white" }}
      />
    ),
    accion: true,
  }, // en proceso → pausar
  4: {
    icon: (
      <PlaySquareOutlined
        className="custom-icon"
        style={{ fontSize: "36px", color: "white" }}
      />
    ),
    accion: false,
  }, // pausada → reanudar
};
